"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductVAT_1 = require("../../product/model/ProductVAT");

var ProductVATByProductData_1 = require("../model/ProductVATByProductData");

var ProductVATByProductDataConverter_1 = require("./ProductVATByProductDataConverter");
/**
 * Implementation of {@link ProductVATByProductDataConverter}
 *
 * @author JMe
 */


var ProductVATByProductDataConverterImpl =
/*#__PURE__*/
function (_ProductVATByProductD) {
  _inherits(ProductVATByProductDataConverterImpl, _ProductVATByProductD);

  function ProductVATByProductDataConverterImpl() {
    _classCallCheck(this, ProductVATByProductDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProductDataConverterImpl).apply(this, arguments));
  }

  _createClass(ProductVATByProductDataConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        vatId: conversions.toDocumentReferenceId(source.vatId),
        validFrom: conversions.asObject(source, 'validFrom', function (v) {
          return conversions.fromDate(v);
        }),
        validTo: conversions.asObject(source, 'validTo', function (v) {
          return conversions.fromDate(v);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductVATByProductData_1.ProductVATByProductData(ProductVAT_1.ProductVAT.schema.vatId.valueOf(conversions.toClassReferenceId(source.vatId)), ProductVAT_1.ProductVAT.schema.validFrom.valueOfField(source), ProductVAT_1.ProductVAT.schema.validTo.valueOfField(source));
    }
  }]);

  return ProductVATByProductDataConverterImpl;
}(ProductVATByProductDataConverter_1.ProductVATByProductDataConverter);

exports.ProductVATByProductDataConverterImpl = ProductVATByProductDataConverterImpl;